import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IRelatedAssetType, RelatedAssetType } from '@app/core/model/entities/asset/asset-type';
import { EntityFieldBuilder } from '@app/shared/components/fields/entity-field-builder/abstract-entity-field-builder';


@Component({
  selector: 'asset-type-field-builder',
  templateUrl: './asset-type-field-builder.component.html',
  styleUrl: './asset-type-field-builder.component.scss',
  standalone: false
})
export class AssetTypeFieldBuilderComponent extends EntityFieldBuilder<IRelatedAssetType, RelatedAssetType> implements OnInit, AfterViewInit {
  /**
   * Navigates to the entity sheet view.
   * This method resolves immediately for this component.
   */
  public navigateToEntitySheet(): Promise<void> {
    return Promise.resolve();
  }

  /**
   * Instantiate a RelatedAssetType
   *
   * @param relatedAssetType
   * @return RelatedAssetType
   */
  protected newRelatedEntity(relatedAssetType: IRelatedAssetType): RelatedAssetType {
    return new RelatedAssetType(relatedAssetType);
  }
}
